const numberOfEmployees = ['1-5', '6-10', '11-20', '21-50', '51-100', '100+'];

export default numberOfEmployees;
